"use client";
import { useCallback } from "react";
import { TYPEAHEAD_PLACE_TYPE_CODE, resolveFeedbackUrl } from "../constants/typeahead-endpoints.js";
function useTypeAheadFeedback(config) {
    return useCallback(({ item, selectedPosition, selectedChildPosition, typeAheadEndpoint, neighbourhoodNestingEnabled, fetchedItems, apiDuration, apiSource, isRecentOrRecommendedSearch })=>{
        const base = resolveFeedbackUrl({
            endpointKey: typeAheadEndpoint,
            config
        });
        if (!base) return;
        if (isRecentOrRecommendedSearch) return;
        const { entered, id, itemName, displayName, type, parentId, isIndented } = item;
        if (!entered) return;
        const url = `${base}/${id}/${encodeURIComponent(entered)}/${encodeURIComponent(itemName || displayName || '')}/${selectedPosition ?? ''}`;
        const queryParams = new URLSearchParams({
            language: 'en',
            locale: 'en-US',
            placeType: TYPEAHEAD_PLACE_TYPE_CODE[type] ?? type
        });
        const shouldAppendNestingParams = 'flights' === typeAheadEndpoint || 'hotelsV2' === typeAheadEndpoint && neighbourhoodNestingEnabled && Boolean(isIndented);
        if (shouldAppendNestingParams) {
            if (isIndented) queryParams.set('isIndented', 'true');
            if (parentId) queryParams.set('parentId', parentId);
            if (null != selectedChildPosition) queryParams.set('selectedChildPosition', String(selectedChildPosition));
        }
        const isHotel = 'hotels' === typeAheadEndpoint || 'hotelsV2' === typeAheadEndpoint;
        isHotel ? fetch(`${url}?${queryParams}`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                items: fetchedItems,
                apiDuration,
                source: apiSource
            })
        }) : fetch(`${url}?${queryParams}`);
    }, [
        config
    ]);
}
export { useTypeAheadFeedback };
